import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { EntidadBeneficiariaDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class EntidadBeneficiariaService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getEntidadBeneficiariaService(): Observable<BodyListResponse<EntidadBeneficiariaDTO>> {
    return this.http.get<BodyListResponse<EntidadBeneficiariaDTO>>(API_URL + '/api/v1/entidadBeneficiaria/todos');
  }
  getEntidadBeneficiariaActivasService(): Observable<BodyListResponse<EntidadBeneficiariaDTO>> {
    return this.http.get<BodyListResponse<EntidadBeneficiariaDTO>>(API_URL + '/api/v1/entidadBeneficiaria');
  }

  getEntidadBeneficiariaPorTipoService(codigo: String): Observable<BodyListResponse<EntidadBeneficiariaDTO>> {
    console.log('codigo', API_URL + '/api/v1/entidadBeneficiaria/tipo/' + codigo);
    return this.http.get<BodyListResponse<EntidadBeneficiariaDTO>>(API_URL + '/api/v1/entidadBeneficiaria/tipo/' + codigo);
  }

  guardarEntidadBeneficiariaService(entidadBeneficiariaDTO: EntidadBeneficiariaDTO): Observable<BodyResponse<EntidadBeneficiariaDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/entidadBeneficiaria', entidadBeneficiariaDTO);
  }

  getEntidadBeneficiariaPorCodigoEntidadBeneficiariaService(codigoEntidadBeneficiaria: string): Observable<BodyResponse<EntidadBeneficiariaDTO>> {
    return this.http.get<BodyResponse<EntidadBeneficiariaDTO>>(API_URL + '/api/v1/entidadBeneficiaria/' + codigoEntidadBeneficiaria);
  }
  /*** codigos de acceso entidad */

  getGenerarCodigoAccesoEntidadBeneficiariaService(numeroIdentidad: string): Observable<BodyResponse<string>> {
    return this.http.get<BodyResponse<string>>(API_URL + '/api/v1/entidadBeneficiaria/generarAccesoEntidad/' + numeroIdentidad);
  }

  getValidarAccesoEntidadBeneficiariaService(numeroIdentidad: string, codigoAcceso: string): Observable<BodyListResponse<boolean>> {
    return this.http.get<BodyListResponse<boolean>>(API_URL + '/api/v1/entidadBeneficiaria/validarAccesoEntidad/' + numeroIdentidad + '/' + codigoAcceso);
  }
}
